export const articles = [
  {
    id: 1,
    title: "چطور منوی دیجیتال باعث افزایش فروش رستوران شما می‌شود",
    summary: "منوی دیجیتال تجربه مشتری را بهبود می‌بخشد و باعث افزایش فروش رستوران می‌شود.",
    content: `در دنیای امروز، مشتریان انتظار دارند تجربه سفارش غذا سریع، ساده و جذاب باشد. منوی دیجیتال با دسته‌بندی مناسب، عکس‌های جذاب و پیشنهادات ویژه باعث افزایش رضایت مشتری و فروش رستوران می‌شود.`,
    author: "تیم بامیزبان",
    date: "1403/09/20",
    tags: ["ویژه", "جدید"],
    image: "/images/article/delivery.png",
    bg: "bg-blue-50",
    border: "border-blue-500",
  },
  {
    id: 2,
    title: "10 روش ساده برای بهبود تجربه مشتری در رستوران‌ها",
    summary: "نکات کاربردی برای ایجاد حس رضایت و راحتی مشتریان.",
    content: `ایجاد تجربه مثبت مشتری شامل عوامل مختلفی است؛ از رفتار کارکنان تا طراحی منو و فضای رستوران. رعایت این نکات باعث بازگشت مشتریان و افزایش فروش می‌شود.`,
    author: "تیم بامیزبان",
    date: "1403/09/18",
    tags: ["پر بازدید"],
    image: "/images/article/article-1.png",
    bg: "bg-red-50",
    border: "border-red-500",
  },
  {
    id: 3,
    title: "راهنمای کامل ساخت منوی جذاب و کاربرپسند",
    summary: "مراحل طراحی منو با دسته‌بندی مناسب و عکس‌های حرفه‌ای.",
    content: `یک منوی دیجیتال خوب باعث می‌شود مشتری راحت‌تر انتخاب کند. از عکس با کیفیت، توضیحات کوتاه و پیشنهادات ویژه استفاده کنید.`,
    author: "تیم بامیزبان",
    date: "1403/09/19",
    tags: ["جدید"],
    image: "/images/article/article-2.png",
    bg: "bg-green-50",
    border: "border-green-500",
  },
  {
    id: 4,
    title: "ترفندهای افزایش رضایت مشتری با نمایش عکس حرفه‌ای غذاها",
    summary: "چگونگی تاثیر عکس‌ها بر انتخاب مشتری و افزایش فروش.",
    content: `عکس‌های حرفه‌ای و جذاب باعث تحریک اشتهای مشتری می‌شوند. انتخاب زاویه مناسب، نورپردازی و پس‌زمینه ساده توصیه می‌شود.`,
    author: "تیم بامیزبان",
    date: "1403/09/17",
    tags: ["پر بازدید"],
    image: "/images/article/article-2.png",
    bg: "bg-yellow-50",
    border: "border-yellow-500",
  },
  {
    id: 5,
    title: "چطور منوی دیجیتال هزینه‌ها و زمان کارکنان را کاهش می‌دهد",
    summary: "سریع‌تر شدن سفارش و کاهش خطاها با منوی دیجیتال.",
    content: `با استفاده از منوی دیجیتال، مشتری سفارش خود را مستقیم ثبت می‌کند و نیاز به کارکنان کمتر می‌شود. این موضوع هزینه‌ها و خطاهای انسانی را کاهش می‌دهد.`,
    author: "تیم بامیزبان",
    date: "1403/09/15",
    tags: ["جدید"],
    image: "/images/article/party-1.png",
    bg: "bg-purple-50",
    border: "border-purple-500",
  },
  {
    id: 6,
    title: "5 اشتباه رایج در طراحی منوی رستوران",
    summary: "اشتباهات متداول در چیدمان منو که فروش را کاهش می‌دهند.",
    content: `قرار دادن آیتم‌های کم سود در بالای منو، عکس‌های بی‌کیفیت و توضیحات طولانی از جمله اشتباهاتی هستند که مشتری را گیج می‌کنند.`,
    author: "تیم بامیزبان",
    date: "1403/09/16",
    tags: ["پر بازدید"],
    image: "/images/article/party-3.png",
    bg: "bg-pink-50",
    border: "border-pink-500",
  },
];
